import React, { FC, useContext } from 'react'
import classNames from 'classnames'
import { useGlobalToast } from 'transfix-ui/components/Toast/GlobalToast'
import { makeStyles } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { FeatureFlagsContext } from 'utils/context/FeatureFlagsContext'
import { NormFileGeneratorStatus } from 'apps/marketplace/apiTypes/normFileGeneratorStatuses'
import { Table, TableHead, TableBody, TableCell, TableRow } from 'transfix-ui'
import { NormingJobsTableRow } from './NormingJobsTableRow'

enum TABLE_COLUMNS {
  jobId = 'Job ID',
  rfpId = 'RFP ID',
  createdAt = 'Created At',
  shipper = 'Shipper',
  rfpName = 'RFP Name',
  googleSheetsUrl = 'Google Sheets URL',
  status = 'Status',
  creator = 'Creator',
  dueDate = 'Due Date',
  workSpace = 'Workspace',
  options = '',
  auditWorkspace = '',
}

interface INormingJobsTableProps {
  normingJobs: NormFileGeneratorStatus[]
}

const useStyles = makeStyles({
  noDisplay: {
    display: 'none !important',
  },
})

export const NormingJobsTable: FC<INormingJobsTableProps> = ({
  normingJobs = [],
}: INormingJobsTableProps) => {
  const { openToast } = useGlobalToast()
  const classes = useStyles()

  const { getFlag } = useContext(FeatureFlagsContext)
  const { enabled: displayRfpStatusTag } = getFlag('displayRfpStatusTag')

  if (normingJobs.length === 0) {
    return (
      <Box my={2} textAlign='center'>
        <Typography variant='h3'>No Norming Jobs Found</Typography>
      </Box>
    )
  }
  const onRetrySuccess = (message: string) => {
    openToast({
      toastMessage: message,
      toastType: 'default',
    })
  }
  const onRetryError = (errorMessage: string) => {
    openToast({
      toastMessage: errorMessage,
      toastType: 'alert',
    })
  }

  const tableClass = (value: string) => {
    return classNames({
      [classes.noDisplay]: !displayRfpStatusTag && value === 'Workspace',
    })
  }

  return (
    <Table>
      <TableHead>
        <TableRow tableCellType='th'>
          {Object.entries(TABLE_COLUMNS).map(([key, value]) => (
            <TableCell
              tableCellType='th'
              key={`${key}-column-header`}
              dataTest={`${key}-column-header`}
              className={tableClass(value)}>
              {value}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody dataTest='norming-jobs-table'>
        {normingJobs.map(job => (
          <NormingJobsTableRow
            key={job.id}
            normingJob={job}
            onRetrySuccess={onRetrySuccess}
            onRetryError={onRetryError}
          />
        ))}
      </TableBody>
    </Table>
  )
}
